import { render } from "./ModalBody.vue?vue&type=template&id=9d7f94a6&scoped=true"
import script from "./ModalBody.vue?vue&type=script&lang=js"
export * from "./ModalBody.vue?vue&type=script&lang=js"

import "./ModalBody.vue?vue&type=style&index=0&id=9d7f94a6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1003992750/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d7f94a6"]])

export default __exports__